/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

import store from '@/store';
import customerService from '@/services/customer';
import storageService from '@/services/storage';
import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

const getImageUrl = hash => `${process.env.API_LOCATION}api/Containers/${process.env.GS_BUCKET}/download/${encodePathSegment(hash)}?access_token=${encodeURIComponent(store.state.auth.token)}`;

const getUploadUrl = () => `${process.env.API_LOCATION}api/Containers/${process.env.GS_BUCKET}/upload`;

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue')
  },
  data() {
    return {
      form: {
        name: '',
        refCode: '',
        customerGroup: '',
        email: '',
        birthday: null,
        addresses: [{
          title: '',
          name: '',
          address: '',
          district: '',
          subDistrict: '',
          province: '',
          zipCode: '',
          country: ''
        }],
        referrer: '',
        remark: '',
        images: [],
      },
      selectedAddress: '1',
      tabIndex: 1,
      imgDialog: false,
      imageActionURL: getUploadUrl(),
      dialogImgUrl: '',
      fileList: [],
    }
  },
  props: ['id'],
  mounted() {
    this.getCustomer();
    this.getAddress();
    store.dispatch('group/getGroup', {});
  },
  computed: {
    count() {
      return store.state.customer.count;
    },
    groups() {
      return store.state.group.groups;
    },
    imageHeaders() {
      return {
        Authorization: store.state.auth.token,
      };
    },
  },
  watch: {},
  methods: {
    getAddress() {
      customerService.getAddress(this.id, (err, res) => {
        if (res.data.length < 1) {
          this.form.addresses = [{
            name: '1',
            title: 'Address 1',
            address: '',
            district: '',
            subDistrict: '',
            province: '',
            zipCode: '',
            country: '',
          }]
        } else {
          this.selectedAddress = res.data[0].name;
          this.tabIndex = parseInt(res.data[res.data.length - 1].name, 10);
          this.form.addresses = res.data;
        }
      });
    },
    getCustomer() {
      customerService.getOne(this.id, null, (err, res) => {
        if (err) return;
        if (!res.data.birthday) {
          // fix birthday selection issue
          delete res.data.birthday;
          res.data.birthday = '';
        }

        if (!res.data.images) {
          res.data.images = [];
        } else {
          // generate fileList
          const newDataImages = [];

          res.data.images.forEach((v) => {
            console.log(v);
            this.fileList.push({
              url: getImageUrl(v),
              filename: v,
            });
            newDataImages.push(v);
          });

          res.data.images = newDataImages;
        }

        res.data.customerGroup = res.data.customerGroupId;

        this.form = res.data;
      });
    },
    onSubmit(form) {
      this.form.newAddresses = this.form.addresses;
      customerService.edit(form, (err) => {
        if (err) return console.log(err);
        Vue.router.push({
          name: 'customer.view',
        });
        return true;
      });
    },
    addTab() {
      const id = this.tabIndex + 1;
      this.tabIndex = id;
      this.form.addresses.push({
        title: `Address ${this.tabIndex}`,
        name: `${this.tabIndex}`,
        address: '',
        district: '',
        subDistrict: '',
        province: '',
        zipCode: '',
        country: '',
      })
      this.selectedAddress = `${id}`;
    },
    removeTab(targetName) {
      const tabs = this.form.addresses;
      let activeName = this.selectedAddress;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.selectedAddress = `${activeName}`;
      this.form.addresses = this.form.addresses.filter(tab => tab.name !== targetName);
    },
    handleRemove(file) {
      this.form.images = this.form.images.filter(img => img !== file.filename);
      storageService.del(file.filename);
    },
    handlePictureCardPreview(file) {
      this.imgDialog = true;
      this.dialogImgUrl = file.url;
    },
    handleImageUploaded(response) {
      this.form.images.push(response.result.files.file[0].name);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/customer/edit/index.js